/**
 * Rubina Irfan - Global Scripts
 * Scroll reveal animations and shared functionality
 */

// Elements carrying .ri-reveal start at opacity 0 (see ri-global.css, shipped
// inside ri-critical.css) and are painted only once .ri-visible lands on them.
// Anything that misses its reveal therefore does not degrade to "unanimated" -
// it stays invisible while still taking up its full height, which reads as a
// blank gap on the page. Two ways that used to happen, both fixed below.
const REVEAL_SELECTOR = '.ri-reveal:not(.ri-visible)';

function reveal(el) {
  el.classList.add('ri-visible');
  revealObserver.unobserve(el);
}

// Scroll Reveal Observer
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) reveal(entry.target);
  });
}, { threshold: 0.12 });

function observeReveals(root) {
  (root || document).querySelectorAll(REVEAL_SELECTOR).forEach((el) => {
    revealObserver.observe(el);
  });
}

/**
 * Safety net for the second failure mode. An IntersectionObserver reports
 * threshold *crossings*, so an element that travels from below the fold to
 * above it inside a single frame - a flick scroll on a phone, a jump to an
 * anchor - is never sampled at 12% visible and no callback ever arrives. It
 * then keeps opacity 0 for the rest of the session. Sweeping once scrolling
 * settles catches those; on a collection grid this was leaving whole rows of
 * products blank.
 */
function sweepReveals() {
  document.querySelectorAll(REVEAL_SELECTOR).forEach((el) => {
    if (el.getBoundingClientRect().top < window.innerHeight) reveal(el);
  });
}

let sweepTimer;
function scheduleSweep() {
  clearTimeout(sweepTimer);
  sweepTimer = setTimeout(sweepReveals, 150);
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  observeReveals();
  window.addEventListener('scroll', scheduleSweep, { passive: true });
  window.addEventListener('resize', scheduleSweep, { passive: true });
});

// Re-initialize for dynamically added content (Shopify sections)
window.reinitScrollReveal = () => observeReveals();

/**
 * The first failure mode: content appended after load - collection infinite
 * scroll - was never handed to the observer at all, so every product past the
 * first page stayed invisible. The section fires this event after each append.
 */
document.addEventListener('ri:products:added', (event) => {
  observeReveals(event.detail && event.detail.container);
  scheduleSweep();
});

// Shopify section reload support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', window.reinitScrollReveal);
}
